import { useOperatorPulse } from 'hooks/useOperatorPulse';
import React, { ReactElement } from 'react';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { authSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const AuthProvider = (props: { children: ReactElement }) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: authSaga });

  useOperatorPulse();

  return <>{React.Children.only(props.children)}</>;
};
